import React, { useContext } from 'react';
import styled from 'styled-components';

import Typography from 'kingpin/atoms/Typography';
import Row from 'components/Common/Row';
import useKbDomains from 'hooks/useKbDomains';

import AiReadyReportRow from './AiReadyReportRow';
import CoverageSummary from './CoverageSummary';
import { AiReadyContext } from './AiReadyProvider';
import { domainsForReport } from './constants';

// The agent's roster: what it can reach, what it cannot tell apart, and what is
// in each report. When a `domain` is given the roster is narrowed to reports
// that reach that domain skill, and the coverage summary is hidden (the domain
// panel shows its own).

const SectionDiv = styled.div`
  padding: 24px 32px;
`;

const AiReadyReportList = ({
  domain,
  onAddTest,
}: {
  // When set, only reports whose collapsed domains include this skill are shown.
  domain?: string;
  onAddTest?: (params: {
    report: AiReady.AnalysedReport;
    metricId?: string;
  }) => void;
} = {}) => {
  const { aiReady, coverage } = useContext(AiReadyContext);
  const { domainGroups } = useKbDomains();

  const reports = domain
    ? aiReady.filter((report) =>
        domainsForReport({ tags: report.domains, domainGroups }).includes(
          domain,
        ),
      )
    : aiReady;

  return (
    <SectionDiv data-testid="ai-ready-report-list">
      {!domain && (
        <>
          <Row centerAlign style={{ gap: 12 }}>
            <Typography.Header type="H4">AI-ready reports</Typography.Header>
            <Typography.Body type="Body 12" color="var(--color-text-secondary)">
              {coverage.reachableMetricIds.length} metric(s) reachable
            </Typography.Body>
          </Row>
          <CoverageSummary coverage={coverage} />
        </>
      )}

      {reports.length === 0 && (
        <Typography.Body type="Body 13" color="var(--color-text-secondary)">
          No report on this account is flagged AI-ready, so the agent has
          nothing to answer from.
        </Typography.Body>
      )}
      {reports.map((report) => (
        <AiReadyReportRow
          key={report.reportId}
          report={report}
          onAddTest={onAddTest}
        />
      ))}
    </SectionDiv>
  );
};

export default AiReadyReportList;
